import { BeRow, BeStack, BeTable, type BeTableColumn, type BeTableRow, BeText } from "@beos-css/react/index.ts";
import { useState } from "react";
import iconBeide from "../../icons/beide.png";
import iconBeide32 from "../../icons/beide-32.png";
import iconPeople from "../../icons/people.png";
import iconPeople32 from "../../icons/people-32.png";
import iconTerminal from "../../icons/terminal.png";
import iconTerminal32 from "../../icons/terminal-32.png";

const columns: BeTableColumn[] = [
	{ id: "name", title: "Name", width: 150, sortable: true },
	{ id: "size", title: "Size", width: 70, align: "right" },
	{ id: "kind", title: "Kind", width: 110, sortable: true },
];

const rows: BeTableRow[] = [
	{ id: "beide", icon: { mini: iconBeide, large: iconBeide32 }, cells: { name: "BeIDE", size: "1.2 MB", kind: "Application" } },
	{ id: "terminal", icon: { mini: iconTerminal, large: iconTerminal32 }, cells: { name: "Terminal", size: "256 KB", kind: "Application" } },
	{
		id: "people",
		icon: { mini: iconPeople, large: iconPeople32 },
		cells: { name: "People", size: "180 KB", kind: "Application" },
		decoration: "underline",
	},
];

const bare: BeTableRow[] = rows.map(({ icon, ...row }) => row);

export function TableLinearDemo() {
	const [tableSel, setTableSel] = useState<string[]>(["terminal"]);

	return (
		<section id="demo-table">
			<h3>Table view -- linear (BeTable / Tracker list)</h3>
			<p>
				A multi-column file list. Click a row to select it, or a sortable header to sort; "People" carries the dotted rule R5 draws under a
				symlink, and the third copy selects the way Tracker does -- the name only, white on black.
			</p>
			<BeRow wrap gap="row">
				<BeStack gap="tight">
					<BeText face="mini">default</BeText>
					<BeTable
						columns={columns}
						rows={rows}
						sort={{ columnId: "name", ascending: true }}
						onSort={() => {}}
						selectedIds={tableSel}
						onSelectItem={(id) => setTableSel([id])}
					/>
				</BeStack>

				<BeStack gap="tight">
					<BeText face="mini">splitHeader</BeText>
					<BeTable
						splitHeader
						columns={columns}
						rows={rows}
						sort={{ columnId: "name", ascending: true }}
						onSort={() => {}}
						selectedIds={tableSel}
						onSelectItem={(id) => setTableSel([id])}
					/>
				</BeStack>
				<BeStack gap="tight">
					<BeText face="mini">nameSelection</BeText>
					<BeTable
						nameSelection
						columns={columns}
						rows={rows}
						sort={{ columnId: "name", ascending: true }}
						onSort={() => {}}
						selectedIds={tableSel}
						onSelectItem={(id) => setTableSel([id])}
					/>
				</BeStack>
				<BeStack gap="tight">
					<BeText face="mini">no icons</BeText>
					<BeTable
						columns={columns}
						rows={bare}
						sort={{ columnId: "name", ascending: true }}
						onSort={() => {}}
						selectedIds={tableSel}
						onSelectItem={(id) => setTableSel([id])}
					/>
				</BeStack>
			</BeRow>
		</section>
	);
}
